import React, {
  HTMLProps,
  useEffect,
  useMemo,
  useState,
  useRef,
  useContext,
} from "react";
import styled, { css } from "styled-components";

import axios from "axios";
import { useScreenClass } from "react-grid-system";
import { useHistory } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb";
import Icon, { ClickableIcon } from "../../components/Icon";
import { Col, Row } from "../../components/StyledGridSystem";
import Status from "../../types/enum/Status";
// import FlexBox from '../../components/FlexBox';
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import Card from "../../components/Card";
import Input, {
  InputContainer,
  InputIconContainer,
} from "../../components/Input";
import Table from "../../components/Table";
import {
  StyledText,
  Subtitle,
  TextSize,
  TextStatus,
} from "../../components/Text";
import {
  CourseContent,
  FilterValue,
  EmptyCourseContent,
} from "../../filter/FilterValue";
import useDebounce from "../../components/use-debounce";
import theme from "../../styles/theme";
import Button from "../../components/Button";
import colorName from "../../styles/colors";

import ConfirmModal from "../../components/ConfirmModal";
import CourseSelectModal from "../../components/CourseSelectModal";
import { StudentContext } from "../../context/StudentBehalfContext";
import { UserContext } from "../../context/UserContext";
import MinimalSelect from "../../components/MinimalSelect";
import SnackBar from "../../components/SnackBar";
import { isError } from "util";
import { set } from "react-hook-form";

export interface Ioption {
  semester: any;
  program: any;
  time: any;
  day: any;
}
const TBody = styled.tbody`
  tr:last-child: {
    td: {
      border-bottom: none;
    }
  }
  tr:last-child td {
    border-bottom: none;
  }
`;
const sharedMinimalStyle = css`
  min-width: 200px;
  border-color: hsl(0, 0%, 80%);
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  padding: 0px 12px;
  .react-select__menu {
    text-align: left;
    width: 100%;
    min-width: unset;
    margin-left: -12px;
  }
`;

const StyledMinimalSelect = styled(MinimalSelect)`
  ${sharedMinimalStyle}
`;

const FilterStyled = styled.div<
  { isMobile?: boolean } & HTMLProps<HTMLDivElement>
>`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: ${({ theme }) => theme.spacing.x2};
`;

const RowStyled = styled.div`
  display: flex;
  flex-flow: column;
`;

function AddCoursesPage(props: any) {
  const { student, isBehalf } = useContext(StudentContext);
  const { user } = useContext(UserContext);
  const { termID } = props.location.state;
  const { termName } = props.location.state;
  const { programId } = props.location.state;
  const screenClass = useScreenClass();
  const isMobile = useMemo(() => ["xs", "sm"].includes(screenClass), [
    screenClass,
  ]);
  const test = [
    { name: "Courses", link: "/courses/myCourses" },
    { name: "My Courses", link: "/courses/myCourses" },
    { name: "Add Courses", link: "/courses/add-courses" },
  ];
  const [posts, setPosts] = useState<Array<any>>([]);
  const [selectedCourses, setSelectedCourses] = useState<Array<any>>([]);
  const [isItem, setIsItem] = useState(false);
  const [offset, setOffSet] = useState(0);
  const [limit, setLimit] = useState(10);
  const [totalPage, setTotalPage] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSelectionModalOpen, setIsSelectionModalOpen] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [term, setTerm] = useState("");
  const [currentCourse, setCurrentCourse] = useState<CourseContent>(
    EmptyCourseContent
  );
  // const [courses, setCourses] = useState();
  const [searchValue, setSearchValue] = useState("");
  const debouncedSearchTerm = useDebounce(searchValue, 300);
  const [loading, setLoading] = useState(true);
  const [options, setOptions] = useState({
    semester: [],
    program: [{ label: "All", value: "All" }],
    time: [],
    day: [],
  });

  const [filters, setfilters] = useState({
    semester: "",
    program: [],
    time: [],
    day: [],
    sort: "Course Code",
  });
  const [programOption, setProgramOption] = useState<Array<{ label: string; value: string; isDisabled?: boolean }>>([
    { label: "", value: "", isDisabled: false },
  ]);

  const [selectedProgram, setSelectedProgram] = useState<{
    label: string;
    value: string;
  }>(() => {
    const item = localStorage.getItem("selectedProgram");
    return item ? JSON.parse(item) : { label: "", value: "" };
  });

  const [latestSemester, setLatestSemester] = useState<FilterValue>({
    label: "",
    value: "",
  });
  const [allCourses, setAllCourses] = useState<Array<any>>([]);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
  const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [message, setMessage] = useState("");

  const toggleSelects = (id: number, sectionName: String) => {
    // console.log(id);
    setPosts(
      posts.map((course: any) =>
        course.id === id
          ? {
              ...course,
              isSelected: !course.isSelected,
            }
          : course
      )
    );
  };
  const toggleSelect = (id: number, sectionName: String) => {
    setPosts(updateObjectInArray(posts, id, sectionName));
  };
  const getSectionName = (course: any) =>
    course.sections
      .filter((obj: any) => obj.isSelected && obj.isSelected === true)
      .map((obj: any) => obj.name);

  // function updateObjectInArray(
  //   array: any[],
  //   courseId: any,
  //   sectionName: String
  // ) {
  //   return array.map((item: any) => {

  //         console.log('array',item)

  //     if (item.id !== courseId) {
  //       return item;
  //     }
  //     return {
  //       ...item,
  //       isSelected: !item.isSelected,
  //       sections: item.sections?.map((content: any) =>
  //         content.name === sectionName
  //           ? { ...content, isSelected: !content.isSelected }
  //           : content
  //       ),
  //     };
  //   });
  // }

  function updateObjectInArray(
    array: any[],
    courseId: any,
    sectionName: String
  ) {
    return array.map((item: any) => {

      if (item.sections?.[0].id !== courseId) {
        // This isn't the item we care about - keep it as-is
        return item;
      }
      // Otherwise, this is the one we want - return an updated value
      return {
        ...item,
        isSelected: !item.isSelected,
        sections: item.sections?.map((content: any) =>
          content.name === sectionName
            ? { ...content, isSelected: !content.isSelected }
            : content
        ),
      };
    });
  }

  const getShortDay = (day: String) => {
    switch (day) {
      case "Monday":
        return "Mon";
      case "Tuesday":
        return "Tue";
      case "Wednesday":
        return "Wed";
      case "Thursday":
        return "Thu";
      case "Friday":
        return "Fri";
      case "Saturday":
        return "Sat";
      case "Sunday":
        return "Sun";
      default:
        return day;
    }
  };
  const fetchTerm = () => {
    setLoading(true);
    setTerm("Fall 2021");
    // axios.get('/api/v1/terms/add-course-period').then((res) => {
    //   setTerm(res.data.data.name);
    //   setLoading(false);
    // }).catch((err) => {
    //   setLoading(false);
    // });
  };

  const isInitialRender = useRef(true);

  useEffect(() => {
    fetchTerm();
    if (user.role === "admin" && isBehalf) {
      fetchProgram(student.student_id);
    } else {
      fetchProgram(user.student_id);
    }
  }, []);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
    } else {
      setfilters({ ...filters, semester: term });
    }
  }, [term]);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
    } else if (posts != null) {
      setSelectedCourses(posts.filter((course) => course.isSelected === true));
    }
  }, [posts]);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
    } else if (user.role === "admin" && isBehalf) {
      fetchPostbyPage(student.student_id, selectedProgram.value);
    } else {
      fetchPostbyPage(user.student_id, selectedProgram.value);
    }
  }, [filters, student, user, selectedProgram]);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
    } else {
      // console.log(selectedCourses);
    }
  }, [selectedCourses]);

  const fetchUserInfo = (id: string) => {
      setLoading(true);
      axios
        .get(`/api/v1/students/${id}`)
        .then((res) => {
          // setProgramId(res.data.data.program.id);
  
          const tempPrograms: Array<{ label: string; value: string; isDisabled?: boolean }> = [];
          !selectedProgram.value &&
            setSelectedProgram({
              label:
                res.data.data.programs[0].short_name +
                " (" +
                res.data.data.programs[0].activity_type_name +
                ")",
              value: res.data.data.programs[0].program_id,
            });
  
          !localStorage.getItem("selectedProgram") &&
            localStorage.setItem(
              "selectedProgram",
              JSON.stringify({
                label:
                  res.data.data.programs[0].short_name +
                  " (" +
                  res.data.data.programs[0].activity_type_name +
                  ")",
                value: res.data.data.programs[0].program_id,
              })
            );
  
          res.data.data.programs.map(
            (program: {
              program_id: string;
              short_name: string;
              activity_type_name: string;
            }) =>
              tempPrograms.push({
                label:
                  program.short_name + " (" + program?.activity_type_name + ")",
                value: program.program_id,
              })
          );
          setProgramOption(tempPrograms);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    };
  const fetchProgram = (id: string) => {
    setLoading(true);
    axios
      // .get(`/api/v1/courses/programs`)
      .get(`/api/v1/students/${id}`)
      .then((res) => {
        // setProgramId(res.data.data.program.id);

      //   const tempPrograms: Array<{ label: string; value: string }> = [];
      //   !selectedProgram.value &&
      //     setSelectedProgram({
      //       label: res.data.data.programs[0].short_name,
      //       value: res.data.data.programs[0].id,
      //     });

      //   // !localStorage.getItem("selectedProgram") &&
      //   //   localStorage.setItem(
      //   //     "selectedProgram",
      //   //     JSON.stringify({
      //   //       label:
      //   //         res.data.data.programs[0].short_name,
      //   //       value: res.data.data.programs[0].id,
      //   //     })
      //   //   );

      //   res.data.data.programs.map(
      //     (program: {
      //       id: string;
      //       short_name: string;
      //       activity_type_name: string;
      //     }) =>
      //       tempPrograms.push({
      //         label: program.short_name,
      //         value: program.id,
      //       })
      //   );
      //   setProgramOption(tempPrograms);
      //   setLoading(false);
      // })
      // .catch((err) => {
      //   setLoading(false);
      // });
       const tempPrograms: Array<{ label: string; value: string; isDisabled?: boolean }> = [];
          !selectedProgram.value &&
            setSelectedProgram({
              label:
                res.data.data.programs[0].short_name +
                " (" +
                res.data.data.programs[0].activity_type_name +
                ")",
              value: res.data.data.programs[0].program_id,
            });
  
          !localStorage.getItem("selectedProgram") &&
            localStorage.setItem(
              "selectedProgram",
              JSON.stringify({
                label:
                  res.data.data.programs[0].short_name +
                  " (" +
                  res.data.data.programs[0].activity_type_name +
                  ")",
                value: res.data.data.programs[0].program_id,
              })
            );
  
          res.data.data.programs.map(
            (program: {
              program_id: string;
              short_name: string;
              activity_type_name: string;
            }) => {
              const isDisabled = ["WITHDRAWN", "GRADUATED"].includes(program.activity_type_name);
              tempPrograms.push({
                label: `${program.short_name} (${program.activity_type_name})`,
                value: program.program_id,
                isDisabled, 
              });
            }
          );
          setProgramOption(tempPrograms);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
  };

  const handleSearchChange = (text: string) => {
    // eslint-disable-next-line max-len
    // const filtered = posts.filter((data) => {
    //   // eslint-disable-next-line max-len
    //   if (
    //     data.short_name.toLowerCase().includes(text.toLowerCase())
    //     || data.code.toLowerCase().includes(text.toLowerCase())
    //   ) {
    //     return true;
    //   }
    //   return false;
    // });
    const filtered = allCourses.filter((data) => {
      const search = text.toLowerCase();
      return (
        data.short_name?.toLowerCase().includes(search) ||
        data.code?.toLowerCase().includes(search) ||
        data.full_name?.toLowerCase().includes(search)
      );
    });
    setSearchValue(text);
    setPosts(filtered);
  };

  const openModal = (data: any) => {
    if (data) {
      setCurrentCourse(data);
      setIsModalOpen(true);
    }
  };
  const openSelectionModal = (data: any) => {
    if (data) {
      setCurrentCourse(data);
      setIsSelectionModalOpen(true);
    }
  };
  const ColumnName = (isMobile: boolean) => {
    if (isMobile) {
      return (
        <>
          <th></th>
          <th></th>
        </>
      );
    }
    return (
      <>
        <th>Course Code</th>
        <th>Course Name</th>
        <th>Section</th>
        <th>Units</th>
        <th></th>
      </>
    );
  };

  const history = useHistory();

  const addCourses = () => {
    setIsConfirmModalOpen(true);
  };
  // const getIds = (array: any[], keys_to_keep = ['id']) => array.map((o) => keys_to_keep.reduce((acc: any, curr: any) => {
  //   acc[curr] = o[curr];
  //   return acc;
  // }, {}));
  const getIds = (array: any[]) =>
    array?.map((course) => ({
      id:
        course?.sections && course?.sections?.length > 0
          ? course?.sections?.[0]?.id
          : null,
    }));
  const confirmAddCourses = () => {
    if (
      user.role === "admin" ||
      isBehalf ||
      student.student_id !== "" ||
      selectedCourses.length > 0
    ) {
      let studentId = user.student_id;
      if (user.role === "admin") {
        studentId = student.student_id;
      }
      setLoading(true);
      // eslint-disable-next-line camelcase
      const course_ids = getIds(selectedCourses);
      axios
        .post(`/api/v1/students/courses/add`, {
          sections: course_ids, // currently session id, need to change later after backend changes
          student_id: studentId,
          program_id: programId,
          source_program_id: selectedProgram.value,
        })
        .then((res:any) => {
          setIsConfirmModalOpen(false);
          const path = "/courses/myCourses";
          history.push(path,{ message: res.data.data, showSnack: true  });
          setLoading(false);
          // setIsSnackbarOpen(true);
          setMessage(res.data.data);
        })
        .catch((error) => {
          setLoading(false);
          setErrorSnackbarOpen(true);
          setMessage(error?.response?.data?.error || "Failed to add courses. Please try again.");
          console.log(error);
        });
    }
  };

  const fetchPostbyPage = (studentId: string, programId: string) => {
    setLoading(true);
    // let studentId = user.student_id;
    // if (user.role === 'admin') {
    //   studentId = student.student_id;
    // }
    axios
      // .get('/api/v1/courses')
      .get(
        `/api/v1/students/courses/offer?studentId=${studentId}&termId=${termID}&programId=${programId}`
      )
      .then((res) => {
        if (
          res.data.data.courses != null &&
          res.data.data.courses.length !== 0
        ) {
          res.data.data.courses.forEach((ele: any, index: number) => {
            res.data.data.courses[index].isSelected = false;
          });
        }
        setAllCourses(res.data.data.courses);
        setPosts(res.data.data.courses);
        setIsItem(false);
        if (!res.data.courses) {
          setIsItem(true);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
    // if (dummyData.data.courses != null) {
    //   if (dummyData.data.courses.length != 0) {
    //     dummyData.data.courses.forEach((ele: any, index: number) => {
    //       dummyData.data.courses[index].isSelected = false;
    //     });
    //   }
    // }
    // setPosts(dummyData.data.courses);
    // console.log(posts);
    // setIsItem(false);
    // setLoading(false);
  };
  const closeTest = (courseId: any, section: any) => {
    toggleSelect(courseId, section);
  };

  return (
    <>
     <SnackBar
          isOpen={isSnackbarOpen}
          setOpen={setIsSnackbarOpen}
          type="success"
          message={message}
        />
        <SnackBar
          isOpen={errorSnackbarOpen}
          setOpen={setErrorSnackbarOpen}
          type="error"
          message={message}
        />
      <CourseSelectModal
        isOpen={isSelectionModalOpen}
        setOpen={setIsSelectionModalOpen}
        currentCourse={currentCourse}
        closeTest={closeTest}
      />
      <ConfirmModal
        isOpen={isConfirmModalOpen}
        setOpen={setIsConfirmModalOpen}
        selectedCourses={selectedCourses}
        confirmAddCourses={confirmAddCourses}
      />
      <Row>
        <Col>
          <Breadcrumb path={test} />
        </Col>
      </Row>
      <Row>
        <Col>
          <FlexBox space={2}>
            <h2 style={{ marginRight: "auto", marginBottom: 0 }}>
              Enroll Courses{" "}
              <span style={{ color: "#af000b" }}>
                ({programOption?.find((p: any) => p.value === programId)?.label}
                )
              </span>
            </h2>
          </FlexBox>
        </Col>
      </Row>
      <Row>
        <Col sm={8}>
          <Card style={{ marginTop: "0px" }}>
            <Row>
              <h3>Select Courses to Enroll</h3>
              {programOption?.[0].value &&<Col style={{ textAlign: "end" }}>
                {" "}
                <StyledMinimalSelect
                  value={programOption.find(
                    (data) => data.value === selectedProgram.value
                  )}
                  onChange={(data: { label: string; value: string }) => {
                    setSelectedProgram(data);
                    // localStorage.setItem("selectedProgram", JSON.stringify(data));
                  }}
                  options={programOption.sort((a:any, b:any) => a.label?.localeCompare(b.label))}
                />
              </Col>}
            </Row>

            <Subtitle style={{ marginBottom: "0px" }}>
              {termName || "N/A"}
            </Subtitle>
            <InputContainer
              as="form"
              onSubmit={() => {}}
              style={{ width: "100%", margin: "16px 0px" }}
            >
              <Input
                id="search-input"
                name="searchInput"
                // eslint-disable-next-line max-len
                onInput={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleSearchChange(e.target.value)
                }
                placeholder="Find courses..."
                value={searchValue}
                style={{ width: "inherit", padding: "6px 12px" }}
              />
              <InputIconContainer onClick={(e: any) => e.preventDefault()}>
                <Icon name="search" status={Status.default} />
              </InputIconContainer>
            </InputContainer>
            <Table hoverable>
              <thead>
                <tr>{ColumnName(isMobile)}</tr>
              </thead>
              <tbody>
                {!loading && posts ? (
                  posts.map((data, key) => {
                    if (!isMobile) {
                      return (
                        <tr
                          key={key}
                          style={
                            // eslint-disable-next-line max-len
                            data.isSelected
                              ? { backgroundColor: theme.color.primaryLight }
                              : { backgroundColor: "#FFFFFF" }
                          }
                          onClick={() => openSelectionModal(data)}
                        >
                          <td>
                            <StyledText
                              textSize={TextSize.default}
                              // status={TextStatus.disabled}
                            >
                              {data.code}
                            </StyledText>
                          </td>
                          <td>
                            {data.short_name}
                            {data.isSelected && data.sections && (
                              <p style={{ color: colorName.primary }}>
                                Selected Section:{" "}
                                {data.sections.map((sect: any) =>
                                  sect.isSelected ? sect.name : ""
                                )}
                              </p>
                            )}
                          </td>
                          <td>{data.sections ? data.sections[0].name : "-"}</td>
                          <td>{data.units}</td>
                          <td>
                            {!data.isSelected && data.sections?.length === 1 && (
                              <ClickableIcon
                                name="plus-s"
                                title="Select"
                                style={{
                                  color: colorName.primary,
                                  alignItems: "center",
                                }}
                                status={Status.primary}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleSelect(data.sections[0].id, data.sections[0].name);
                                }}
                              />
                            )}
                            {!data.isSelected && !data.sections && (
                              <ClickableIcon
                                name="plus-s"
                                title="Select"
                                style={{
                                  color: colorName.primary,
                                  alignItems: "center",
                                }}
                                status={Status.primary}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleSelect(data.id, "");
                                }}
                              />
                            )}
                            {!data.isSelected && data.sections?.length > 1 && (
                              <ClickableIcon
                                name="plus-s"
                                title="Select"
                                style={{
                                  color: colorName.primary,
                                  alignItems: "center",
                                }}
                                status={Status.primary}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  openSelectionModal(data);
                                }}
                              />
                            )}
                            {data.isSelected && (
                              <ClickableIcon
                                name="x-s"
                                color={theme.color.textDisabled}
                                title="Deselect"
                                style={{
                                  color: theme.color.textDisabled,
                                  alignItems: "center",
                                }}
                                status={Status.primary}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleSelect(
                                    data.sections[0].id,
                                    String(getSectionName(data))
                                  );
                                }}
                              />
                            )}
                            {/* <Icon ml={0.5} size={1.5} name="plus-s" />Select */}
                          </td>
                        </tr>
                      );
                    }

                    return (
                      <tr key={data.id}>
                        <td onClick={() => openModal(data)}>
                          <RowStyled>
                            <StyledText style={{ fontWeight: "bold" }}>
                              {data.short_name}
                            </StyledText>
                            <StyledText status={TextStatus.muted}>
                              {data.code}
                            </StyledText>
                            <StyledText status={TextStatus.muted}>
                              {data.units} Units ·{data.sections.length}{" "}
                              Sections
                            </StyledText>
                          </RowStyled>
                        </td>
                        <td style={{ verticalAlign: "middle" }}>
                          {/* <ClickableIcon
                            name="plus-s"
                            status={Status.primary}
                            onClick={() => openModal(data)}
                          /> */}
                          {!data.isSelected && data.sections?.length === 1 && (
                            <ClickableIcon
                              name="plus-s"
                              title="Select"
                              style={{
                                color: colorName.primary,
                                alignItems: "center",
                              }}
                              status={Status.primary}
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleSelect(data.id, data.sections[0].name);
                              }}
                            />
                          )}
                          {!data.isSelected && !data.sections && (
                            <ClickableIcon
                              name="plus-s"
                              title="Select"
                              style={{
                                color: colorName.primary,
                                alignItems: "center",
                              }}
                              status={Status.primary}
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleSelect(data.id, "");
                              }}
                            />
                          )}
                          {!data.isSelected && data.sections?.length > 1 && (
                            <ClickableIcon
                              name="plus-s"
                              title="Select"
                              style={{
                                color: colorName.primary,
                                alignItems: "center",
                              }}
                              status={Status.primary}
                              onClick={(e) => {
                                e.stopPropagation();
                                openSelectionModal(data);
                              }}
                            />
                          )}
                          {data.isSelected && (
                            <ClickableIcon
                              name="x-s"
                              color={theme.color.textDisabled}
                              title="Deselect"
                              style={{
                                color: theme.color.textDisabled,
                                alignItems: "center",
                              }}
                              status={Status.primary}
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleSelect(
                                  data?.sections?.[0]?.id,
                                  String(getSectionName(data))
                                );
                              }}
                            />
                          )}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <div></div>
                )}
              </tbody>
            </Table>
            {!loading ? (
              <div></div>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  padding: theme.spacing.x2,
                }}
              >
                <Icon
                  name="spinner"
                  spin
                  size={4}
                  color={theme.color.textDisabled}
                />
                {/* <CircularProgress disableShrink /> */}
              </div>
            )}
          </Card>
        </Col>
        <Col sm={4}>
          <Card style={{ marginTop: "0px" }}>
            {/* <h5>No coursed selected</h5>
            <Subtitle>Units</Subtitle> */}
            {/* style={{ marginBottom: _theme.spacing.x2 }} */}

            <FlexBox
              alignItems="flex-start"
              style={
                selectedCourses.length !== 0
                  ? { paddingBottom: "16px" }
                  : { paddingBottom: "0px" }
              }
            >
              <FlexGrow grow={2}>
                {selectedCourses.length == 0 ? (
                  <h3>No Courses Selected</h3>
                ) : (
                  <h3>{selectedCourses.length} Course(s) Selected</h3>
                )}
                <Subtitle>
                  {selectedCourses.reduce((a, b) => a + b.units, 0)} Units
                </Subtitle>
              </FlexGrow>
              <FlexGrow
                grow={0}
                style={{
                  marginLeft: "auto",
                  textAlign: "right",
                  alignSelf: "center",
                }}
              >
                <FlexBox direction="column" alignItems="flex-end">
                  <Button
                    disabled={selectedCourses.length < 1}
                    onClick={() => {
                      addCourses();
                    }}
                    status={Status.primary}
                  >
                    Next
                    <Icon mr={1} name="chevron-right-s" />
                  </Button>
                </FlexBox>
              </FlexGrow>
            </FlexBox>

            <Table>
              <TBody>
                {selectedCourses.map((data, key) => {
                  if (!isMobile) {
                    return (
                      <tr key={key}>
                        <td
                          style={{ paddingBottom: "16px", paddingTop: "16px" }}
                        >
                          {data.code}/{data.short_name}
                          <Subtitle style={{ margin: "0px" }}>
                            {data.sections &&
                              data.sections[0].schedule &&
                              data.sections[0].schedule.map((days: any) => [
                                `${getShortDay(days.day)} ${days.start}-${
                                  days.end
                                }`,
                                <br />,
                              ])}
                            <StyledText status={TextStatus.muted}>
                              {data.sections && data.sections[0].name} ·{" "}
                              {data.sections &&
                                data.sections[0].lecturers &&
                                data.sections[0].lecturers.map(
                                  (lecturer: any, i: any, arr: any) => {
                                    if (arr.length - 1 === i) {
                                      return [`${lecturer.name}`];
                                    }
                                    return [`${lecturer.name} · `];
                                  }
                                )}
                            </StyledText>
                          </Subtitle>
                          <Subtitle style={{ margin: "0px" }}>
                            {data.units} Units ·{" "}
                            {data.sections && data.sections[0].seat == 0 ? (
                              <>
                                <StyledText status={TextStatus.primary}>
                                  {data.sections[0].seat}/
                                  {data.sections[0].capacity} Seats Left
                                </StyledText>
                                <StyledText
                                  status={TextStatus.muted}
                                  style={{ paddingLeft: "8px" }}
                                >
                                  (add to waitlist)
                                </StyledText>
                              </>
                            ) : (
                              <StyledText
                                status={TextStatus.muted}
                                style={{ paddingLeft: "8px" }}
                              >
                                {data.sections ? data.sections[0].seat : "N"}/
                                {data.sections
                                  ? data.sections[0].capacity
                                  : "A"}{" "}
                                Seats Left
                              </StyledText>
                            )}
                          </Subtitle>
                        </td>
                        <td
                          style={{
                            paddingBottom: "16px",
                            paddingTop: "16px",
                            verticalAlign: "middle",
                          }}
                        >
                          <Icon
                            ml={0.5}
                            size={3}
                            name="x-s"
                            onClick={() => toggleSelect(data?.sections?.[0]?.id, "")}
                          />
                        </td>
                      </tr>
                    );
                  }

                  return (
                    <tr key={data.id}>
                      <td
                        style={{
                          paddingBottom: "16px",
                          paddingTop: "16px",
                          verticalAlign: "middle",
                        }}
                      >
                        <RowStyled>
                          <StyledText style={{ fontWeight: "bold" }}>
                            {data.short_name}
                          </StyledText>
                          <StyledText status={TextStatus.muted}>
                            {data.code}
                          </StyledText>
                          <StyledText status={TextStatus.muted}>
                            {data.units} Units ·{data.sections.length} Sections
                          </StyledText>
                        </RowStyled>
                      </td>
                      <td
                        style={{
                          paddingBottom: "16px",
                          paddingTop: "16px",
                          verticalAlign: "middle",
                        }}
                      >
                        <Icon
                          ml={0.5}
                          size={3}
                          name="x-s"
                          onClick={() => toggleSelect(data.id, "")}
                        />
                      </td>
                    </tr>
                  );
                })}
              </TBody>
            </Table>
          </Card>
        </Col>
      </Row>
    </>
  );
}
export default AddCoursesPage;
